const token = {
  get: () => {
    const item = window.localStorage.getItem('token');
    return item;
  },
  remove: () => {
    const item = window.localStorage.removeItem('token');
    return item;
  },
  set: newToken => {
    const item = window.localStorage.setItem('token', newToken);
    return item;
  },
};

export default token;
